export default function ErrorScreen({ message }: { message?: string }) {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-20 px-10">
      <h1 className="text-center font-condensed text-[2.5rem] font-bold uppercase leading-none md:text-6xl">
        Oh No!
      </h1>
      {message && (
        <p className="text-center text-xl font-medium">
          <b className="font-bold">Error:</b> {message}
        </p>
      )}
    </div>
  );
}
